import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import DashBoardFirstSection from "./DashBoardComponent/DashBoardFirstSection";
import DashBoardFourthSection from "./DashBoardComponent/DashBoardFourthSection";
import DashBoardOperationThirdSection from "./DashBoardComponent/DashBoardOperationThirdSection";
import DashBoardSecondSection from "./DashBoardComponent/DashBoardSecondSection";
import DashBoardThirdSection from "./DashBoardComponent/DashBoardThirdSection";
import { DashBoardContainer } from "./dashBoardNewStyles";

const DashBoardNew = ({
  history,
  //states
  selectedOrganization,
  jobsCustomIsloading,
  jobsCustom,
  attendanceIsLoading,
  attendanceData,
  //add performers states
  performersIsLoading,
  topPerformers,
  //add revenue states
  revenueIsLoading,
  lastYearRevenue,
  thisYearRevenue,
  currentMonthIndex,
  completeJobCompareIsLoading,
  lastYearCompleteJobCompare,
  thisYearCompleteJobCompare,
  completeJobCompareCurrentMonthIndex,
  //add top customers states
  topCustomersIsLoading,
  topCustomers,
  //add estimation states
  estimationIsLoading,
  estimationData,
  //add organization sales states
  organizationSalesIsLoading,
  organizationSalesData,
  //add organization jobs states
  organizationJobsIsLoading,
  organizationJobsData,
  //add project count states
  projectCountIsLoading,
  projectCountData,
  //add timesheet count states
  timesheetCountIsLoading,
  timesheetCountData,
  operationTopSectionIsLoading,
  operationTopSectionData,
  recentCompletedJobsIsLoading,
  recentCompletedJobsData,
  serviceTopSectionIsLoading,
  serviceTopSectionData,
  //actions
  getJobInfoToday,
  getJobInfoCustom,
  getDashboardAttendance,
  getDashboardPerformers,
  getDashboardRevenue,
  getDashboardCompleteJobCompare,
  getDashboardTopCustomers,
  getDashboardEstimation,
  getDashboardOrganizationSales,
  getDashboardOrganizationJobs,
  getDashboardProjectCount,
  getDashboardOperationTopSection,
  getDashboardRecentCompletedJobs,
  getDashboardTimesheetCount,
  getDashboardServiceTopSection,
}) => {
  // Dynamic labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";

  return (
    <div className="content">
      <DashBoardContainer>
        {/* 1st section */}
        <DashBoardFirstSection
          selectedOrganization={selectedOrganization}
          // getDashboardProjectCount={getDashboardProjectCount}
          getDashboardOperationTopSection={getDashboardOperationTopSection}
          // projectCountIsLoading={projectCountIsLoading}
          // projectCountData={projectCountData}
          // getDashboardTimesheetCount={getDashboardTimesheetCount}
          // timesheetCountIsLoading={timesheetCountIsLoading}
          // timesheetCountData={timesheetCountData}
          serviceTopSectionIsLoading={serviceTopSectionIsLoading}
          serviceTopSectionData={serviceTopSectionData}
          getDashboardServiceTopSection={getDashboardServiceTopSection}
          operationTopSectionIsLoading={operationTopSectionIsLoading}
          operationTopSectionData={operationTopSectionData}
          history={history}
        />
        <DashBoardSecondSection
          selectedOrganization={selectedOrganization}
          getJobInfoCustom={getJobInfoCustom}
          jobsCustomIsloading={jobsCustomIsloading}
          jobsCustom={jobsCustom}
          getDashboardAttendance={getDashboardAttendance}
          attendanceIsLoading={attendanceIsLoading}
          attendanceData={attendanceData}
          getDashboardPerformers={getDashboardPerformers}
          performersIsLoading={performersIsLoading}
          topPerformers={topPerformers}
          history={history}
        />

        {isOperationType ? (
          <DashBoardOperationThirdSection
            selectedOrganization={selectedOrganization}
            getDashboardCompleteJobCompare={getDashboardCompleteJobCompare}
            completeJobCompareIsLoading={completeJobCompareIsLoading}
            lastYearCompleteJobCompare={lastYearCompleteJobCompare}
            thisYearCompleteJobCompare={thisYearCompleteJobCompare}
            currentMonthIndex={completeJobCompareCurrentMonthIndex}
            getDashboardOrganizationJobs={getDashboardOrganizationJobs}
            organizationJobsIsLoading={organizationJobsIsLoading}
            organizationJobsData={organizationJobsData}
          />
        ) : (
          <DashBoardThirdSection
            getDashboardRevenue={getDashboardRevenue}
            revenueIsLoading={revenueIsLoading}
            lastYearRevenue={lastYearRevenue}
            thisYearRevenue={thisYearRevenue}
            currentMonthIndex={currentMonthIndex}
            selectedOrganization={selectedOrganization}
            getDashboardOrganizationSales={getDashboardOrganizationSales}
            organizationSalesIsLoading={organizationSalesIsLoading}
            organizationSalesData={organizationSalesData}
          />
        )}

        <DashBoardFourthSection
          getDashboardTopCustomers={getDashboardTopCustomers}
          topCustomersIsLoading={topCustomersIsLoading}
          topCustomers={topCustomers}
          selectedOrganization={selectedOrganization}
          getDashboardEstimation={getDashboardEstimation}
          estimationIsLoading={estimationIsLoading}
          estimationData={estimationData}
          history={history}
          getDashboardRecentCompletedJobs={getDashboardRecentCompletedJobs}
          recentCompletedJobsIsLoading={recentCompletedJobsIsLoading}
          recentCompletedJobsData={recentCompletedJobsData}
        />
      </DashBoardContainer>
    </div>
  );
};

export default DashBoardNew;
